// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import colors from "../../config/colors";
import fonts from "../../config/fonts";
const RangeDataPickerStyle = StyleSheet.create({
  container: {
    flex: 1,
  },
  buttonContainer: {
    backgroundColor: colors.green,
    borderRadius: 10,
    padding: 4,
    flexDirection: "row",
  },
  buttonText: {
    color: colors.white,
    fontWeight: "bold",
    fontSize: 16,
    fontFamily: fonts.regular,
  },
  calendarContainer: {
    borderRadius: 10,
    padding: 10,
  },
});

export default RangeDataPickerStyle;
